import { Controller } from "@hotwired/stimulus";
import { toggleDropzoneValidity, handleDropzoneUploadSuccess, isEmpty } from "../../components/dropzone";
import { isStringTrue } from "../../utils/misc";

export default class extends Controller {
  static targets = ["hasContractInput"];
  static outlets = ["basic-file-upload"];

  connect() {
    this.dropzone = this.basicFileUploadOutlet.dropzone;
    handleDropzoneUploadSuccess(this.dropzone, this.element);
  }

  validateSubmission(e) {
    e.preventDefault();

    if (!this._answeredToContractPresence()) {
      $(this.hasContractInputTarget).parsley().validate();
      return;
    }

    if (this._hasContract() && isEmpty(this.dropzone)) {
      toggleDropzoneValidity(this.dropzone, false);
      return;
    }

    this._submitForm();
  }

  _answeredToContractPresence() {
    return !!this._contractPresenceAnswer();
  }

  _contractPresenceAnswer() {
    return this.hasContractInputTargets.find((input) => input.checked);
  }

  _submitForm() {
    if (this._hasContract()) {
      this.dropzone.processQueue();
    } else {
      Rails.fire(this.element, "submit");
    }
  }

  _hasContract() {
    return isStringTrue(this._contractPresenceAnswer().value);
  }
}
